import React from 'react';
import PropTypes from 'prop-types';
import { lowercaseHyphen } from '../../utils/stringConversion';
import { pitchIdentifier } from '../../utils/diagramIdentifierName';
import * as pitches from './Pitches';
import DiagramCreatorOptionTile from './DiagramCreatorOptionTile';
import IconWithText from '../Global/Icons/IconWithText';
import BackButton from '../Global/Buttons/BackButton';

const DiagramCreatorPitchSelect = ({ options, theme, changePitch, onBackClick }) => (
  <div className="diagram-creator-pitch-select">
    <div className="position-relative p-x-5">
      <BackButton onClick={onBackClick} fill="white" size="l" classes="diagram-creator-pitch-select__back-btn position-absolute icon--l" />
      <h2 className="h1 color-white fw-medium">Pick your pitch</h2>
    </div>

    <ul className="tile-btns-container row">
      {options &&
        options.map((option) => {
          const pitchObjectRef = pitchIdentifier(option.value);
          const pitch = pitches[pitchObjectRef];
          const pitchClass = lowercaseHyphen(option.label);
          const tileLabel = <h3 className="tile-btn__title fw-medium no-margin">{option.label}</h3>;

          let pitchChildren;
          let pitchImage;
          if (pitch) {
            pitchChildren = pitch.children;
            // If a 'displayImage' key/value exists on the pitch then display that as the thumbnail (used for pitches with setup equipment like 4 Goal Game)
            if (pitches[pitchObjectRef][theme].displayImage) {
              pitchImage = pitch[theme].displayImage;
            } else {
              pitchImage = pitch[theme].canvasImage;
            }

            // We only want to return anything if there is a pitch match
            return (
              <li key={option.value} className="col-sm-6 col-md-3">
                <DiagramCreatorOptionTile
                  classes={pitchClass}
                  onClick={e => changePitch(e, option)}
                  image={pitchImage}
                >
                  <div className="card-link__text-change">
                    {pitchChildren && pitchChildren.length > 0 ? (
                      <IconWithText name="arrow-right" size="m" iconRight>{tileLabel}</IconWithText>
                    ) : (
                      tileLabel
                    )}
                  </div>
                </DiagramCreatorOptionTile>
              </li>
            );
          }

          // If there is no pitch match then we fail silently
          return null;
        })
      }
    </ul>
  </div>
);

DiagramCreatorPitchSelect.propTypes = {
  options: PropTypes.array,
  theme: PropTypes.string,
  changePitch: PropTypes.func,
  onBackClick: PropTypes.func,
};

export default DiagramCreatorPitchSelect;



// WEBPACK FOOTER //
// ./library/app/components/Diagram/DiagramCreatorPitchSelect.js